import { chain, get, isBoolean, mapValues } from "lodash"
import update from "immutability-helper"

// Can be used to create a default reducer that applies the properties of the action to the state
export function createDefaultReducer(options = {}) {
  return (state, props) => update(state, {
    $merge: {
      ...chain(props)
        .omit(["type", "meta"])
        .thru(props => {
          if (get(options, "convertBoolFalseToNull")) {
            return mapValues(props, prop => isBoolean(prop) && !prop ? null : prop)
          }
          return props
        })
        .value(),
      ...get(options, "customStateValues", {}),
    },
  })
}

// Derived from reduxsauce createReducer function
export function createReducer(handlers) {
  return (state, action) => {
    // missing actions, just return state
    if (!action) return state
    if (!Object.prototype.hasOwnProperty.call(action, "type")) return state

    const handler = handlers[action.type]
    if (!handler || typeof handler !== "function") return state

    return handler(state, action)
  }
}
